<template>
  <div class="PanelProduct">
    <div class="pagination-container top">
      <v-pagination
        v-model="ppage"
        width="100%"
        :length="llength"
        :total-visible="4"
        color="blue"
        @update:modelValue="onPageChange"
      />
    </div>
    <v-card class="card-products">
      <ComponentProduct 
        v-for="product in products" 
        :key="product.idProduct" 
        class="ComponentProduct"
        :product="product"
        @click="$router.push({ name: 'ViewProductView', params: { id: product.idProduct } })"
      />
    </v-card>
    <div class="pagination-container bottom">
      <v-pagination
        v-model="ppage"
        width="100%"
        :length="llength"
        :total-visible="4"
        color="blue"
        @update:modelValue="onPageChange"
      />
    </div>
  </div>
</template>
<script>
import ComponentProduct from './ComponentProduct.vue';

export default {
  name: 'PanelProduct',
  components: {ComponentProduct},
  props: {
    page: {
      type: Number,
      required: true
    },
    length: {
      type: Number,
      required: true
    },
    products: {
      type: Array,
      required: true
    }
  },
  emits: ['onPageChange'],
  data(){
    return {
      ppage: this.page,
      llength: this.length
    }
  },
  watch: {
    page(newVal) {
      this.ppage = newVal
    },
    length(newVal) {
      this.llength = newVal
    }
  },
  methods: {
    onPageChange(){
      this.$emit('onPageChange',this.ppage)
    }
  }
}
</script>
<style scoped>
.PanelProduct{
  background-color: #2d2d2d !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}
.pagination-container.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}
.card-products{
  display: flex;
  flex-direction: row;
  flex-wrap:wrap;
  gap: 10px;
  justify-content: center;
  padding: 50px;
  background-color: #242424;

}
.ComponentProduct{
  /* height auto: la tarjeta se ajusta a su contenido y el flex en fila las
     iguala entre si, en vez de dejar un hueco blanco abajo */
  height: auto;
  width: 200px;
  box-shadow: 0 4px 8px rgba(0,0,0,0.5);
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
  background-color: #1e1e1e; /* Fondo oscuro */
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.5);
}

.pagination-container.bottom {
  margin-top: 10px;
  padding-bottom: 25px;
}

/* Ajuste para el componente de paginación de Vuetify */
.v-pagination {
  background-color: transparent;
}

.v-pagination__item {
  background-color: #2d2d2d !important;
  color: #fff !important;
  border: 1px solid #3a3a3a !important;
}

.v-pagination__item--active {
  background-color: #1976d2 !important; /* Azul del color="blue" */
  color: #fff !important;
}

@media screen and (max-width: 800px) {
  .card-products{
    gap: 5px;
    padding: 5px;
  }
  .ComponentProduct{
    /* Ancho fijo de 180px + el padding del contenedor dejaba caber una sola
       por fila y se perdia media pantalla. Al 50% siempre entran dos. */
    width: calc(50% - 3px);
    height: auto;
  }
}
</style>